import { DrawerProps as MuiDrawerProps } from '@mui/material/Drawer';
import { StyledDrawer } from './styles';

export interface DrawerProps extends MuiDrawerProps {}

export default function Drawer(props: DrawerProps) {
  return <StyledDrawer {...props} />;
}
